import jsPDF from 'jspdf';
// Importação correta do autoTable
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// Exportar para PDF
export const exportToPDF = (dados, titulo) => {
  const doc = new jsPDF('landscape', 'mm', 'a4');
  
  // Título
  doc.setFontSize(16);
  doc.text(titulo, 14, 20);
  doc.setFontSize(10);
  doc.text(`Gerado em: ${new Date().toLocaleDateString('pt-BR')}`, 14, 28);
  
  // Tabela
  const headers = ['Data', 'Descrição', 'Valor', 'Tipo', 'Status', 'Categoria'];
  const rows = dados.map(item => [
    new Date(item.data_lancamento).toLocaleDateString('pt-BR'),
    item.descricao,
    `R$ ${Number(item.valor).toFixed(2)}`,
    item.tipo,
    item.status,
    item.categoria || '-'
  ]);
  
  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: 35,
    theme: 'grid',
    styles: { fontSize: 8 },
    headStyles: { fillColor: [44, 62, 80] }
  });
  
  doc.save(`${titulo}_${new Date().toISOString().split('T')[0]}.pdf`);
};

// Exportar para Excel
export const exportToExcel = (dados, titulo) => {
  const data = dados.map(item => ({
    'Data': new Date(item.data_lancamento).toLocaleDateString('pt-BR'),
    'Descrição': item.descricao,
    'Valor': Number(item.valor),
    'Tipo': item.tipo,
    'Status': item.status,
    'Categoria': item.categoria || '-',
    'Forma Pagamento': item.forma_pagamento || '-',
    'Cliente/Fornecedor': item.pessoa_nome || '-'
  }));
  
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Lançamentos');
  
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], { type: 'application/octet-stream' });
  saveAs(blob, `${titulo}_${new Date().toISOString().split('T')[0]}.xlsx`);
};

// Exportar DRE para PDF
export const exportDREtoPDF = (dados, periodo) => {
  const doc = new jsPDF('portrait', 'mm', 'a4');
  
  doc.setFontSize(18);
  doc.text('Demonstração do Resultado (DRE)', 14, 20);
  doc.setFontSize(11);
  doc.text(`Período: ${periodo}`, 14, 30);
  doc.text(`Gerado em: ${new Date().toLocaleDateString('pt-BR')}`, 14, 37);
  
  const rows = [
    ['RECEITAS', '', ''],
    ['Receita Total', `R$ ${dados.receitas.toFixed(2)}`, ''],
    ['', '', ''],
    ['DESPESAS', '', ''],
    ['Despesas Totais', `R$ ${dados.despesas.toFixed(2)}`, ''],
    ['', '', ''],
    ['RESULTADO', '', `R$ ${dados.saldo.toFixed(2)}`]
  ];
  
  autoTable(doc, {
    body: rows,
    startY: 45,
    theme: 'plain',
    styles: { fontSize: 12 },
    bodyStyles: { cellPadding: 5 }
  });
  
  doc.save(`DRE_${new Date().toISOString().split('T')[0]}.pdf`);
};